import { Component, OnInit, Input } from '@angular/core';
import { CarrierService } from 'app/services/carrier.service';
import { ApplicationService } from 'app/services/application.service';
import { Params, Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-carrier-details',
  templateUrl: './carrier-details.component.html',
  styleUrls: ['./carrier-details.component.css']
})
export class CarrierDetailsComponent implements OnInit {
  @Input() dataCntrl: any;
  public isLoading = false;
  caConfirmObj: any = {};
  message: any;
  oldAppId:any=null;
  appData:any=null;
  duration:any="";
  permitType:any="";
  permitInfo:any="";
  constructor(private carrierService: CarrierService,
    private applicationService: ApplicationService, private router: Router, private activeRoute: ActivatedRoute) { }

  ngOnInit() {
    //console.log('Carrier');
    if (this.router.url.indexOf('change') > 0 || this.router.url.indexOf('duplicate') > 0 || this.dataCntrl.status == 2) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        //console.log(params['id']);

        this.getApp(params['id']);
      });

    }
    if(localStorage.getItem("oldAppId")!=undefined && localStorage.getItem("oldAppId")!=null){
      this.oldAppId=localStorage.getItem("oldAppId");
      this.getApplicationDetails();
    }
  }
  getApplicationDetails(){
    this.applicationService.getById(this.oldAppId).subscribe((data:any) => {
      this.appData=data;
      if(data.permit_type.permit_days > 0){
        this.duration = data.permit_type.permit_days > 0 ? data.permit_type.permit_days + " Days" : null;
      }
      if(data.permit_type.permit_months > 0){
        this.duration = data.permit_type.permit_months > 0 ? data.permit_type.permit_months + " Months" : null;
      }
      if(data.permit_type.permit_years > 0){
        this.duration = data.permit_type.permit_years > 0 ? data.permit_type.permit_years + " Years" : null;
      }
      this.permitType=data.permit_type.description
    });
  }
  getConfirmDetails() {
    this.carrierService.getAccountConfirmationDetailsById(this.dataCntrl.carrierID).subscribe(result => {
      this.caConfirmObj = result;
      //console.log(this.caConfirmObj)
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
    });
  }
  getApp(id) {
    this.isLoading = true;
    this.message = "Retrieving carrier account information, please wait...";
    this.applicationService.getById(id).subscribe((data:any) => {
      //console.log(data);
      this.dataCntrl.application = data;
      this.dataCntrl.carrierID = data.carrier_id;
      this.getConfirmDetails();
    });
  }
  continueRoute() {
    if (this.router.url.indexOf('change') > 0) {
      this.activeRoute.params.subscribe((params: Params) => {
        this.dataCntrl.application.id = params['id'];
        const ctrlType = params['ctrlType'];
        if (ctrlType != 'vehicle' && this.router.url.indexOf('correction') < 0) {
          return this.applicationService.setTab(3);
        }
        if (ctrlType === 'vehicle') {
          return this.applicationService.setTab(2);
        }
        if (this.router.url.indexOf('correction') > 0) {
          return this.applicationService.setTab(1);
        }
      });

    }
    if (this.router.url.indexOf('duplicate') > 0)
      return this.applicationService.setTab(5);
  }
}
